import React from "react";
import { TbCheck } from "react-icons/tb";
import styles from "./CustomStepper.module.css";

const CustomStepper = ({
  steps = [],
  activeStep = 0,
  onStepClick,
  allowNavigation = false,
  className = "",
}) => {
  return (
    <div className={`${styles.stepper} ${className}`}>
      {steps.map((step, index) => {
        const label = typeof step === "string" ? step : step.label;
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;
        const isClickable = allowNavigation && onStepClick && index <= activeStep;

        return (
          <React.Fragment key={label}>
            {index > 0 && (
              <span
                className={`${styles.connector} ${
                  isCompleted || isActive ? styles.connectorFilled : ""
                }`}
              />
            )}
            <div className={styles.step}>
              <button
                type="button"
                className={`${styles.circle} ${
                  isCompleted ? styles.circleCompleted : ""
                } ${isActive ? styles.circleActive : ""}`}
                onClick={() => isClickable && onStepClick(index)}
                disabled={!isClickable}
                aria-current={isActive ? "step" : undefined}
              >
                {isCompleted ? <TbCheck /> : index + 1}
              </button>
              <span
                className={`${styles.label} ${
                  isActive ? styles.labelActive : ""
                }`}
              >
                {label}
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CustomStepper;
